import { render, staticRenderFns } from "./chinese_Culture_Video_Exhibition_2025.vue?vue&type=template&id=81d2d526&scoped=true"
import script from "./chinese_Culture_Video_Exhibition_2025.vue?vue&type=script&lang=js"
export * from "./chinese_Culture_Video_Exhibition_2025.vue?vue&type=script&lang=js"
import style0 from "./chinese_Culture_Video_Exhibition_2025.vue?vue&type=style&index=0&id=81d2d526&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d2d526",
  null
  
)

export default component.exports